import Modal from "react-bootstrap/Modal";
import React, { useContext, useState } from "react";
import Button from "react-bootstrap/Button";
import { useRef } from "react";
import { LanguageContext } from "../../utils/Language";

function ConfirmDialogButton(props) {
  const [showDialog, setShowDialog] = useState(false);
  const resolver = useRef();
  const { dictionary } = useContext(LanguageContext);

  const handleOnClick = async () => {
    const result = await handleShow();
    result && props.onClick();
  };

  const handleShow = () => {
    setShowDialog(true);

    return new Promise(function (resolve) {
      resolver.current = resolve;
    });
  };

  const handleOk = () => {
    resolver.current && resolver.current(true);
    setShowDialog(false);
  };

  const handleCancel = () => {
    resolver.current && resolver.current(false);
    setShowDialog(false);
  };

  const handleHide = () => {
    setShowDialog(false);
    console.log(showDialog);
  };

  return (
    <>
      <Button
        variant={props.variant}
        style={props.style}
        onClick={() => handleOnClick()}
        disabled={props.disabled}
      >
        {props.children}
      </Button>

      <Modal show={showDialog} onHide={handleHide} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.body}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>
            {dictionary.Cancel}
          </Button>
          <Button variant="primary" onClick={handleOk}>
            {dictionary.Accept}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ConfirmDialogButton;
